import { c as _c } from "react/compiler-runtime";
import React from 'react';
type HeadingProps = React.ComponentPropsWithoutRef<'h1'> & {
  level: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'; // The level is one of these specific strings
  children: React.ReactNode;
  className?: string;
  // Only relevant if we were to render a <button>, not used here
};
export function Heading(t0) {
  const $ = _c(10);
  let children;
  let level;
  let rest;
  let t1;
  if ($[0] !== t0) {
    ({
      level,
      children,
      className: t1,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = level;
    $[3] = rest;
    $[4] = t1;
  } else {
    children = $[1];
    level = $[2];
    rest = $[3];
    t1 = $[4];
  }
  const className = t1 === undefined ? "" : t1;
  const Tag = level;
  const t2 = `${"font-bold"} ${className}`;
  let t3;
  if ($[5] !== Tag || $[6] !== children || $[7] !== rest || $[8] !== t2) {
    t3 = <Tag className={t2} {...rest}>{children}</Tag>;
    $[5] = Tag;
    $[6] = children;
    $[7] = rest;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}